// extracted by mini-css-extract-plugin
module.exports = {"cell":"style__cell__7aa1g","label":"style__label__21RPN","checkToggle":"style__checkToggle__4-uM3"};